const responsive_mixin = {
  computed: {
    isMobile() {
      return this.$mq === 'sm';
    },
    isTablet() {
      return this.$mq === 'md';
    },
    isDesktop() {
      return this.$mq === 'lg' || this.$mq === 'xl';
    },
    isDesktopWide() {
      return this.$mq === 'xl';
    },
  },
};

export default responsive_mixin;
